module.exports = __webpack_public_path__ + "img/app_icon6.cee56b63.png";